import useIsMobile from 'utils/hooks/useIsMobile'
import {useEffect} from 'react'

const useMobileBackClose = (open: boolean, onClose: () => void) => {
  const isMobile = useIsMobile()

  useEffect(() => {
    if (!isMobile || !open) return

    window.history.pushState(null, '', window.location.href)

    const handlePopState = () => {
      onClose()
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [open, isMobile])
}

export default useMobileBackClose
